import { EOnboaringFormStep } from '@constants';
import { useCallback, useEffect } from 'react';

import { useSignWellScript } from '../../../../../hooks/useSignWellScript';

import { ContractWrapper, FormWrapper } from './Contract.styles';

import { useOnboardingFormLogic } from '@/hooks';
import { useMutateUserContract, useProfile } from '@/store';

export const Contract: React.FC = () => {
  const { startLoadingAfterContract, currentStep } = useOnboardingFormLogic();
  const { isScriptLoaded, openSignWell, closeSignWell } = useSignWellScript();
  const { generateUserContract } = useMutateUserContract();
  const { profile, refetch } = useProfile();

  const handleSetIsContractSigned = useCallback(() => {
    startLoadingAfterContract();
    closeSignWell();
  }, []);

  useEffect(() => {
    refetch();
  }, [currentStep]);

  useEffect(() => {
    if (!isScriptLoaded || !profile || currentStep !== EOnboaringFormStep.FINAL_STEP) {
      return;
    }

    if (!profile?.contract?.isContractSigned && !profile?.contract?.signUrl) {
      generateUserContract(profile);
      return;
    }

    const shouldOpenSignWell =
      (!profile?.contract?.isContractSigned &&
        profile?.contract?.signUrl &&
        !profile?.contract?.contractFile) ||
      (profile?.contract?.isContractSigned &&
        !profile?.contract?.contractFile &&
        profile?.contract?.signUrl) ||
      (!profile?.contract?.isContractSigned &&
        profile?.contract?.signUrl &&
        profile?.contract?.contractFile);

    if (shouldOpenSignWell) {
      openSignWell(profile.contract?.signUrl || '', {
        onComplete: handleSetIsContractSigned,
        onClose: handleSetIsContractSigned
      });
    } else {
      if (
        profile?.contract?.isContractSigned &&
        profile?.contract?.contractFile &&
        profile?.contract?.signUrl
      ) {
        handleSetIsContractSigned();
      }
    }
  }, [
    currentStep,
    profile?.contract?.signUrl,
    profile?.contract?.isContractSigned,
    profile?.contract?.contractFile,
    isScriptLoaded
  ]);

  if (!profile || !profile.legalId || !profile.birthday) {
    return null;
  }

  return (
    <FormWrapper>
      <ContractWrapper id="contract-wrapper" />
    </FormWrapper>
  );
};
